import RessourceReducerFactory from 'helpers/RessourceReducerFactoryHelpers';
import RessourceSelectorsFactory from 'helpers/RessourceSelectorsFactoryHelpers';
import {
    default as createActionCreator,
    HTTP_METHODS,
} from 'helpers/RessourceActionCreatorsFactoryHelpers';

/*
 * Configuration
 */

export const ressourceNamePlural = 'EVENT_TYPES';

/*
 * Actions
 */

export const REQUEST_GET_EVENT_TYPES = `REQUEST_GET_${ressourceNamePlural}`;
export const REQUEST_GET_EVENT_TYPES_SUCCESS = `REQUEST_GET_${ressourceNamePlural}_SUCCESS`;
export const REQUEST_GET_EVENT_TYPES_ERROR = `REQUEST_GET_${ressourceNamePlural}_ERROR`;

export const SET_EVENT_TYPES_PAGE = `SET_${ressourceNamePlural}_PAGE`;
export const SET_EVENT_TYPES_PAGE_SIZE = `SET_${ressourceNamePlural}_PAGE_SIZE`;
export const FLUSH_EVENT_TYPES = `SET_${ressourceNamePlural}`;

/*
 * Reducer
 */

export const APIEventTypesReducer = RessourceReducerFactory({
    ressourceNamePlural,
});

/*
 * Action Creators
 */

export const getEventTypes = createActionCreator({
    type: REQUEST_GET_EVENT_TYPES,
    method: HTTP_METHODS.GET,
    url: '/events_types',
    withPagination: true,
});

/**
 * Create a SET_EVENT_PAGE action
 * @param {integer} page The page to set
 */
export function setEventTypesPage(page) {
    return {
        type: SET_EVENT_TYPES_PAGE,
        payload: {
            page,
        },
    };
}

/**
 * Create a SET_EVENT_PAGE_SIZE action
 * @param {integer} pageSize The page size
 */
export function setEventTypesPageSize(pageSize) {
    return {
        type: SET_EVENT_TYPES_PAGE_SIZE,
        payload: {
            pageSize,
        },
    };
}

/**
 * Create a FLUSH_EVENT action
 */
export function flushEventTypes() {
    return {
        type: FLUSH_EVENT_TYPES,
    };
}

/*
 * Selectors
 */
export const {
    getItemsSelector,
    isLoadingSelector,
    getCountSelector,
    getPageSelector,
    getPageSizeSelector,
    getCurrentItemsSelector,
} = RessourceSelectorsFactory({
    reducerName: 'APIEventTypes',
});
